import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import useWindowSize from '../../hooks/useWindowSize';
import { subscribe_path } from '../../routes';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';

const HeaderSection = ({ isSubscriber }: { isSubscriber: boolean }) => {
  const { width: windowWidth } = useWindowSize();
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();

  return (
    <div className="tw-mt-20 sm:-tw-mt-20 tw-justify-center tw-mx-auto tw-flex lg:tw-justify-end tw-border-solid tw-border-0 tw-border-b tw-border-gray-300">
      <div className="lg:tw-w-10/12 lg:tw-flex-row sm:!tw-px-24 !tw-px-16 md:tw-w-full sm:tw-flex-col-reverse tw-flex tw-justify-between tw-flex-wrap lg:!tw-px-0">
        <div className="sm:tw-mt-24 lg:tw-mt-64 tw-pb-48 sm:tw-pb-64 lg:tw-w-7/12 md:tw-w-full tw-pr-24">
          <div className="tw-font-serif tw-font-medium tw-text-headline-lg md:tw-text-headline-xl tw-text-pro-red ">
            Read The Information first...
            <span className="tw-text-black tw-block">
              {' '}
              or <span className="tw-italic">them</span> later
            </span>
          </div>
          <div className="tw-mt-8 tw-mb-24 tw-font-serif tw-text-style tw-font-normal tw-body-lg tw-text-[#545B69] lg:tw-max-w-[520px]">
            The Information journalists get the news that other newsrooms envy. That’s why our
            exclusive deals, product launches and strategic moves were followed by the New York
            Times, Bloomberg, the Wall Street Journal and dozens of other outlets more than 400
            times in the last year.
          </div>
          <div className="tw-text-headline-sm tw-font-serif tw-font-bold">
            Get the news straight from the source.
          </div>
          {!isSubscriber && (
            <Button
              className="tw-mt-8 tw-w-[240px] !tw-capitalize tw-text-sans !tw-text-body-lg"
              rounded="slight"
              type="button"
              variant="primary"
              href={subscribe_path()}
            >
              Subscribe
            </Button>
          )}
        </div>
        {hydrated &&
          (windowWidth > 1200 ? (
            <div className="tw-flex-shrink-0 lg:tw-w-5/12">
              <img
                className="tw-h-full tw-w-full tw-object-cover"
                src={getImgxSrc({
                  path: 'brand_campaign/heroDesktop.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ) : (
            <div className="tw-flex-shrink-0 tw-w-full">
              <img
                className="tw-hidden sm:tw-flex tw-max-w-lg sm:tw-max-w-full sm:tw-w-full"
                src={getImgxSrc({
                  path: 'brand_campaign/heroMidsize.png',
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="Hero Image"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default HeaderSection;
